import { useEffect, useState } from 'react';
import QRCode from 'qrcode';

interface Props {
  url: string;
  size?: number;
  className?: string;
}

/** Renders a QR code pointing at the public receipt page. Generated client-side. */
export function ReceiptQrCode({ url, size = 96, className }: Props) {
  const [dataUrl, setDataUrl] = useState<string | null>(null);

  useEffect(() => {
    let cancelled = false;
    QRCode.toDataURL(url, { width: size, margin: 1, errorCorrectionLevel: 'M' })
      .then((d) => { if (!cancelled) setDataUrl(d); })
      .catch(() => { if (!cancelled) setDataUrl(null); });
    return () => { cancelled = true; };
  }, [url, size]);

  if (!dataUrl) {
    return <div className={className} style={{ width: size, height: size }} />;
  }

  return <img src={dataUrl} alt="QR" width={size} height={size} className={className} />;
}
